import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import Background from "../../img/S1_background.png";

const S1_Header = () => {
  const MainDiv = styled.div`
  `;
  const Heading = styled.h1`
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
  `;
  return (
    <MainDiv className="pt-3" id="Home">
      <Menu />
      {/* <Container> */}
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
          style={{backgroundColor:'#B82E3C' , margin:'20px 0 0 0'}}
        >
          <Grid xs={12} sm={12} md={12} className="text-center">
            <h1 className="fontweight ">
              <Span>About us</Span>
            </h1>
          </Grid>
        </Grid>
      {/* </Container> */}
    </MainDiv>
  );
};

export default S1_Header;
